import { createRef } from 'react';

const navigationRef = createRef(null);

export const resetNavigation = (options) => {
  navigationRef.current?.reset(options);
};

export default navigationRef;
